import React from 'react'

const CheckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
    <circle cx="28" cy="28" r="26" stroke="#43A047" strokeWidth="2.5" fill="none"/>
    <polyline points="18,28 25,35 38,20" stroke="#43A047" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

interface SubmittedScreenProps {
  ticketId: string
  onBack: () => void
  hasAttachments?: boolean
}

const SubmittedScreen = ({ ticketId, onBack, hasAttachments }: SubmittedScreenProps) => (
  <div style={{
    position: 'absolute',
    top: 0, left: 0, right: 0,
    height: '100vh',
    zIndex: 100,
    backgroundColor: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}>
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px', textAlign: 'center' }}>
      <CheckIcon />

      <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
        <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#0a0d47', margin: 0 }}>Request Submitted!</h2>
        <p style={{ fontSize: '0.875rem', color: '#9ca3af', margin: 0 }}>Your damage report has been received and is being reviewed.</p>
      </div>

      <div style={{
        display: 'flex',
        width: '215.031px',
        height: '70.078px',
        padding: '13px 25px 1px 25px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '4px',
        borderRadius: '4px',
        border: '1px solid #90CAF9',
        background: '#E3F2FD',
        boxSizing: 'border-box',
      }}>
        <p style={{ margin: 0, fontFamily: '"Red Hat Display"', fontSize: '11.5px', fontWeight: 500, lineHeight: '17px', color: '#1565C0' }}>
          Ticket ID: <span style={{ fontWeight: 700, fontSize: '11.5px' }}>{ticketId}</span>
        </p>
        <p style={{ margin: 0, fontFamily: '"Red Hat Display"', fontSize: '11.5px', fontWeight: 500, lineHeight: '17px', color: '#1565C0' }}>
          Status: <span style={{ fontWeight: 700, fontSize: '11.5px' }}>Submitted</span>
        </p>
      </div>

      {hasAttachments && (
        <div style={{
          maxWidth: 320,
          padding: '10px 14px',
          borderRadius: 8,
          border: '1px solid #FFE082',
          background: '#FFF8E1',
          color: '#B26A00',
          fontFamily: '"Red Hat Display"',
          fontSize: '0.8125rem',
          lineHeight: 1.45,
          display: 'flex',
          gap: 8,
          alignItems: 'flex-start',
          textAlign: 'left',
        }}>
          <span style={{ fontSize: '1rem' }}>📎</span>
          <span>Your attachment is being scanned for security and will appear on the ticket within a minute. Refresh the ticket if you don't see it right away.</span>
        </div>
      )}

      <button
        type="button"
        onClick={onBack}
        style={{
          marginTop: '8px',
          padding: '9px 24px',
          borderRadius: '4px',
          border: 'none',
          backgroundColor: '#2196F3',
          color: '#fff',
          fontSize: '0.875rem',
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        Back to Requests
      </button>
    </div>
  </div>
)

export default SubmittedScreen
